import { getSystemConfig } from '@/api/system.api';
import { keycloakRealm, keycloakUrl } from './env';

export const oidcConfiguration = {
  client_id: 'review-app',
  redirect_uri: window.location.origin + '/authentication/callback',
  silent_redirect_uri: window.location.origin + '/silent-renew.html',
  post_logout_redirect_uri: window.location.origin,
  scope: 'openid profile email',
  authority: `${keycloakUrl}/realms/${keycloakRealm}`,
  service_worker_relative_url: '/OidcServiceWorker.js',
  service_worker_only: true,
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: true,
};

const getOidcConfiguration = async (configStorage: string) => {
  if (configStorage === 'online') {
    const systemConfig = await getSystemConfig();
    if (systemConfig?.KEYCLOAK_URL) {
      return {
        ...oidcConfiguration,
        authority: `${systemConfig.KEYCLOAK_URL}/realms/${systemConfig.KEYCLOAK_REALM}`,
      };
    }
    return oidcConfiguration;
  }
  return oidcConfiguration;
};

export default getOidcConfiguration;
